const CryptoJS = require('crypto-js');

// Secret key for encryption (make sure to keep this secret)
const secretKey = "###";

// Function to encrypt data
function encryptData(data, key) {
    return CryptoJS.AES.encrypt(JSON.stringify(data), key).toString();
}

// Function to decrypt data
function decryptData(ciphertext, key) {
    try {
        if (!ciphertext) return null;
        const bytes = CryptoJS.AES.decrypt(ciphertext, key);
        const text = bytes.toString(CryptoJS.enc.Utf8);
        if (!text) return null;
        return JSON.parse(text);
    } catch (e) {
        return null;
    }
}

// Function to clear localStorage while preserving language and theme preferences
function clearLocalStorage() {
    const language = localStorage.getItem("i18nextLng");
    const theme = localStorage.getItem("theme");
    localStorage.clear();
    if (language) {
        localStorage.setItem("i18nextLng", language);
    }
    if (theme) {
        localStorage.setItem("theme", theme);
    }
}

module.exports = {
    encryptData,
    decryptData,
    clearLocalStorage
};